
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/catering/city/[city]/cuisine/[cuisine]",
      function () {
        return require("private-next-pages/order/catering/city/[city]/cuisine/[cuisine].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order/catering/city/[city]/cuisine/[cuisine]"])
      });
    }
  